import React from 'react';

export type ActivityTab = 'comments' | 'history' | 'work-log';

interface ActivityTabsProps {
  activeTab: ActivityTab;
  onTabChange: (tab: ActivityTab) => void;
  commentCount?: number;
  workLogCount?: number;
}

const ActivityTabs: React.FC<ActivityTabsProps> = ({
  activeTab,
  onTabChange,
  commentCount = 0,
  workLogCount = 0,
}) => {
  const tabs: { id: ActivityTab; label: string }[] = [
    { id: 'comments', label: 'Comments' },
    { id: 'history', label: 'History' },
    { id: 'work-log', label: 'Time Log' },
  ];

  return (
    <div className="border-b border-primary-subtle mb-6">
      <div className="flex gap-8">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`pb-3 text-sm font-medium transition-all relative ${
                isActive
                  ? 'text-neutral after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-gradient-to-r after:from-[#8B5CF6] after:to-[#3B82F6]'
                  : 'text-neutral-medium hover:text-neutral'
              }`}
            >
              {tab.label}
              {tab.id === 'comments' && commentCount > 0 && (
                <span className="ml-2 inline-flex items-center justify-center w-5 h-5 bg-gradient-to-br from-[#8B5CF6] to-[#3B82F6] text-white text-[10px] font-bold rounded-full shadow-sm">
                  {commentCount}
                </span>
              )}
              {tab.id === 'work-log' && workLogCount > 0 && (
                <span className="ml-2 inline-flex items-center justify-center w-5 h-5 bg-gradient-to-br from-[#8B5CF6] to-[#3B82F6] text-white text-[10px] font-bold rounded-full shadow-sm">
                  {workLogCount}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityTabs;
